<template>
    <transition name="fade" :duration="{ enter: 15000, leave: 500 }">
        <div v-show="navigating" class="RouteNavigationBlockingLayer" :class="{ blocking: navigating }">
            <div xv-show="show" class="progressbar" />
        </div>
    </transition>
</template>

<script>
export default {
    computed: {
        navigating() {
            return this.$store.state.routerIsNavigating;
        }
    }
};
</script>

<style lang="scss" scoped>
$duration: 15s;

.RouteNavigationBlockingLayer {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1000;
    pointer-events: none;

    &.blocking {
        pointer-events: all;
    }

    &.fade-enter-active .progressbar {
        transition: transform $duration, opacity 1s;
    }
    &.fade-enter .progressbar {
        opacity: 0;
        transform: translate3d(0, 0, 0) scale(0.1, 1);
    }
    &.fade-enter-to .progressbar {
        opacity: 1;
        transform: translate3d(0, 0, 0) scale(1, 1);
    }

    &.fade-leave-active .progressbar {
        transition: transform 1s linear, opacity 0.5s;
    }

    &.fade-leave-to .progressbar {
        opacity: 0;
    }
}

.progressbar {
    transform-origin: top left;
    height: 3px;
    background-color: white;
}

.progressbar.fade-enter-active {
    transition: transform $duration, opacity 1s;
}
.progressbar.fade-enter {
    opacity: 0;
    transform: translate3d(0, 0, 0) scale(0.1, 1);
}
.progressbar.fade-enter-to {
    opacity: 1;
    transform: translate3d(0, 0, 0) scale(1, 1);
}

.progressbar.fade-leave-active {
    transition: transform 1s linear, opacity 1s;
}

.progressbar.fade-leave-to {
    opacity: 0;
}
</style>
